import React from 'react'

const Resume = () => {
    return (
        <section id="resume" className="grey-section">

            <div className="row section-intro" data-aos="fade-up">
                <div className="col-twelve">

                    <h5>Resume</h5>
                    <h1>More of my credentials.</h1>
                </div>   		
            </div>

            <div className="row resume-timeline" data-aos="fade-up">

                <div className="col-twelve resume-header">

                    <h2>Work Experience</h2>

                </div>

                <div className="col-twelve">

                    <div className="timeline-wrap">

                        <div className="timeline-block">

                            <div className="timeline-ico">
                                <i className="fa fa-briefcase"></i>
                            </div>

                            <div className="timeline-header">
                                <h3>Front-End Developer</h3>
                                <p>August 2019 - Present</p>
                            </div>

                            <div className="timeline-content">
                                <h4>Square1</h4>
                                <p>
                                    Working on websites in languages ​​and tools such as CMS (WordPress), PHP, VueJS, Laravel, Homestead, AMP Components, TailwindCSS, Bootstrap, etc.
                                </p>
                            </div>

                        </div>

                        <div className="timeline-block">

                            <div className="timeline-ico">
                                <i className="fa fa-briefcase"></i>
                            </div>

                            <div className="timeline-header">
                                <h3>Intermediate Layout Programmer</h3>
                                <p>August 2014 - July 2019</p>
                            </div>

                            <div className="timeline-content">
                                <h4>Teravision Technologies</h4>
                                <p>
                                    Creating and supporting the development of websites on CMS (WordPress), PHP, ReactJS, XCode using Auto Layout Techniques in Interface builder (Swift and Objetive C). 
                                </p>
                            </div>

                        </div>

                        <div className="timeline-block">

                            <div className="timeline-ico">
                                <i className="fa fa-briefcase"></i>
                            </div>

                            <div className="timeline-header">
                                <h3>Web Developer</h3>
                                <p>July 2010 - July 2014</p>
                            </div>

                            <div className="timeline-content">
                                <h4>Oruga Studio</h4>
                                <p>
                                    Develop web projects on CMS (Joomla and WordPress), PHP, MySQL, HTML5, CSS3, JavaScript, Ajax, jQuery,etc.
                                </p>
                            </div>

                        </div>

                    </div>  			

                </div>
                
            </div> 
            
            <div className="row resume-timeline" data-aos="fade-up">

                <div className="col-twelve resume-header">

                    <h2>Education & Courses</h2>

                </div>

                <div className="col-twelve">

                    <div className="timeline-wrap">

                        <div className="timeline-block">

                            <div className="timeline-ico">
                                <i className="fa fa-graduation-cap"></i>
                            </div>

                            <div className="timeline-content">
                                <h5>UNEFA - Caracas, Venezuela</h5>
                                <h3>T.S.U. Análisis y Diseño de Sistemas Informática</h3>
                                <h4>2007 - 2010</h4>
                            </div>

                        </div>

                        <div className="timeline-block">

                            <div className="timeline-ico">
                                <i className="fa fa-graduation-cap"></i>
                            </div>

                            <div className="timeline-content">
                                <a href="https://www.diplomadosonline.com/" rel="noreferrer" target="_blank"><h5>DiplomadosOnline.com</h5></a>
                                <h3>Diplomado en Gerencia de Proyectos de Tecnología de Información</h3>
                                <h4>2021 - Present</h4>
                            </div>

                        </div>

                        <div className="timeline-block">

                            <div className="timeline-ico">
                                <i className="fa fa-certificate"></i>
                            </div>
                            <div className="timeline-content">
                                <a href="https://platzi.com/" rel="noreferrer" target="_blank"><h5>Platzi</h5></a>
                                <h3><a href="https://platzi.com/clases/laravel-spa/" rel="noreferrer" target="_blank">Single Page Applications on Laravel with Inertia and Vue.js</a></h3>
                                <h4>May 2021</h4>
                            </div>

                        </div>

                        <div className="timeline-block">

                            <div className="timeline-ico">
                                <i className="fa fa-certificate"></i>
                            </div>
                            <div className="timeline-content">
                                <a href="https://platzi.com/" rel="noreferrer" target="_blank"><h5>Platzi</h5></a>
                                <h3><a href="https://platzi.com/clases/next/" rel="noreferrer" target="_blank">Next.js</a></h3>
                                <h4>January 2021</h4>
                            </div>

                        </div>

                        <div className="timeline-block">

                            <div className="timeline-ico">
                                <i className="fa fa-certificate"></i>
                            </div>
                            <div className="timeline-content">
                                <a href="https://www.udemy.com/" rel="noreferrer" target="_blank"><h5>Udemy</h5></a>
                                <h3><a href="https://www.udemy.com/course/curso-react-js/" rel="noreferrer" target="_blank">ReactJS with Hooks, Redux, Context, Firebase</a></h3>
                                <h4>November 2020</h4>
                            </div>

                        </div>

                        <div className="timeline-block">

                            <div className="timeline-ico">
                                <i className="fa fa-certificate"></i>
                            </div>
                            <div className="timeline-content">
                                <a href="https://www.udemy.com/" rel="noreferrer" target="_blank"><h5>Udemy</h5></a>
                                <h3><a href="https://www.udemy.com/course/aprende-redux-con-react-hooks-y-graphql-facilmente/" rel="noreferrer" target="_blank">Redux with React Hooks and GraphQL</a></h3>
                                <h4>November 2020</h4>
                            </div>

                        </div>

                    </div> 			

                </div>
                
            </div>
                
        </section>
    )
}

export default Resume
